export default "__VITE_ASSET__f6290bf8__"